export default "__VITE_ASSET__DBE4beKO__"